export const TYPE_FILTERS = {
  interviews: "kind:'Repo::Session'",
  highlights: '(kind:Clip OR kind:Highlight)',
  reels: 'kind:HighlightReel',
  insights: 'kind:Story',
  survey_results: 'kind:ScreenerResponse',
  files: "kind:'Repo::File'",
  all: undefined
};
